/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneConsent from 'base/components/standalone/Consent';

export const DynamicStandaloneConsent = StandaloneConsent;
export type DynamicStandaloneConsentProps = PropsFromComponent<typeof StandaloneConsent>;

export const DynamicStandaloneConsentWith = (extras: DynamicStandaloneExtras): typeof StandaloneConsent => {
    return function DynamicStandaloneConsent(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Consent');
        return <StandaloneConsent {...mergeProps({ options: { theme } }, props)} />;
    }
}